import { Row } from 'further-ui/components/Layout';
import { FC, PropsWithChildren } from 'react';

type Props = {
  className?: string;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  align?: 'flex-start' | 'center' | 'flex-end';
};

const FiltersGroup: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  justify = 'flex-start',
  align = 'center',
}) => {
  return (
    <Row
      spacing="md"
      breakpoint="md"
      fullWidth
      className={className}
      justify={justify}
      align={align}
    >
      {children}
    </Row>
  );
};

export default FiltersGroup;
